module.exports = __webpack_public_path__ + "img/join_pocket.eb9260be.svg";